import { FC } from 'react'

import { MailOutlined, StarOutlined } from '@ant-design/icons'

import routes from '../../routes'

const headerItems = [
  { label: 'header.navigation.blog', key: routes.blog },
  { label: 'header.navigation.calendar', key: routes.calendars },
  { label: 'header.navigation.standings', key: routes.standings },
  { label: 'header.navigation.results', key: routes.results },
  { label: 'header.navigation.riders', key: routes.riders },
  { label: 'header.navigation.tracks', key: routes.tracks },
  { label: 'header.navigation.about', key: routes.about },
]

const footerItems: { label: string; key: string; Icon: FC }[] = [
  { label: 'footer.navigation.updates', key: routes.updates, Icon: StarOutlined },
  { label: 'footer.navigation.contact', key: routes.contact, Icon: MailOutlined },
]

export { headerItems, footerItems }
